<template>
  <div class="server-container">
    <van-nav-bar
      title="用户服务协议"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="content">
      <h1 class="title">用户服务协议</h1>
      
      <p class="intro">尊敬的用户：</p>
      <p>欢迎使用由安徽一飞信息科技有限公司及其关联方（以下简称"我们"）合法拥有并运营的管理平台产品及服务。</p>
      <p>管理平台是一个提供多样化功能的企业管理与服务平台，包括各版本客户端应用程序以及相关平台的公众号。管理平台相关网站、服务、应用程序与内容，在《用户服务协议》（以下简称"本协议"）中统称为"本服务"。个人用户、授权用户统称为"您"。</p>
      <p>本协议为您与我们之间的有效协议，规定了您下载、安装、注册、登录、使用（统称"使用"）本服务时须遵循的条款与条件。您使用本服务即表示您确认，您具备履行本协议的完整的民事权利能力和民事行为能力；否则，您不应使用本服务。</p>
      <p>在确认使用本服务之前，请您务必仔细阅读、充分理解本协议全部内容，特别是<strong>免除或者限制责任的条款</strong>，免除或限制责任的条款将以粗体标识，您应重点阅读。开通或使用某项服务的单独协议须选择接受或不接受（如有）。您登录管理平台和使用我们提供的服务，即表示您同意接受本协议的约束，如果您不同意本协议的任何内容，或者无法准确理解相关条款的含义，请不要进行后续操作。若您是未满18周岁的自然人，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用本服务。</p>
      
      <h2 class="section-title">一、个人用户、授权用户与提示</h2>
      <p>1.1 您使用本服务时，可能有两种不同身份，包括个人用户及授权用户。相关定义如下：</p>
      <p>（1）个人用户，以个人身份注册和使用本服务的自然人。</p>
      <p>（2）授权用户，指被客户授权或邀请加入客户在管理平台搭建的组织架构，并使用本服务的自然人，包括商户创建人、管理员。其中，经您指定，代您配置本服务、行使后台管理权限的自然人称为管理员（为免歧义，本协议中称为"平台管理员"）；最初代表客户创建团队的，称为商户创建人。</p>
      <p>（3）客户，指通过授权自然人注册本服务账号，搭建组织架构并享有管理权限的法人或其他组织，客户可以邀请个人加入其组织成为其授权用户。</p>
      <p>1.2 个人用户可于注册个人身份账号后，为个人用途使用本服务。个人用户登录后，可于法律与本协议允许范围内，自行决定下载、查阅或保存用户内容或相关信息。</p>
      <p>1.3 客户可邀请授权用户。您同意，除了邀请您使用本服务的客户的工作人员之外，您不会邀请与客户无关的人。您亦同意，为使您及客户的其他授权用户能够享受本服务的部分功能，该客户可能向我们及客户的其他授权用户提供您的信息。该客户收集、使用、共享您信息的行为应遵守相关法律法规要求，我们仅根据客户要求处理您的信息，且不对该客户的相关行为承担法律责任。授权用户的个人信息及用户内容的相关处理请您详细查阅《隐私政策》。</p>
      <p>1.4 作为授权用户，客户有权对您的授权用户身份及基于该身份的相关权益进行管理，包括但不限于加入、删除以及调整权限和限制服务内容等，您保证在遵守本服务相关规范的同时，按照该客户的授权范围和规范使用本服务，如您丧失授权用户身份，我们有权根据客户的指示将基于该身份的服务内容一并删除或转移。请您知悉，客户应独自负责将所有与您使用本服务有关的客户政策和惯例，以及可能影响、限制您使用本服务或访问客户数据的设置向您进行充分说明与告知，我们不就此承担任何责任。</p>
      <p>1.5 针对授权用户使用本服务的情况，若本协议与我们与客户所订立的其他协议规定有所冲突，则以其他协议为准。若您是以授权用户身份使用本服务的，您理解本服务为客户使用的展业工具性质，并非个人消费使用性质。</p>
      <p>1.6 如果您代表客户注册本服务，您承诺已获得客户的充分授权，授权您代表其接受、履行本协议的全部内容。在此情况下，客户将对您使用本服务产生的各项行为在法律和财务方面承担责任。若客户就使用本服务与我们另行达成其他协议，且本协议与其他协议内容有冲突的，相关内容以另行达成的其他协议为准。本协议未提及的内容，以其他协议约定为准。</p>
      
      <h2 class="section-title">二、关于账号</h2>
      <p>2.1 您有权选择合法且符合本服务要求的字符组合作为自己账号的名称，并可对账号自行设置符合安全要求的密码。您设置的账号、密码是您登录并以注册用户身份使用本服务及我们提供的其他软件及相关服务的凭证。请务必维护并按时更新您的个人信息以及其他提供给我们的数据，确保数据完整且符合现况。</p>
      <p>2.2 客户通过授权自然人（即商户创建人）开通本服务后，可以设置不同后台管理系统管理权限的平台管理员，平台管理员可以有一人或多人，具体可由客户及已有的平台管理员自行设定。平台管理员可在本服务管理及维护授权用户的信息，并可以邀请成员加入。客户管理员的行为由客户承担，我们不就客户行为承担责任。</p>
      <p>2.3 您理解并承诺，您应当依照可适用的法律法规使用平台提供的服务，您在本平台的账号等信息仅限您本人使用，不可转让、借用和赠与，否则因此引发的一切责任由您及客户承担。您在绑定和关联平台账户时，应使用您本人真实有效的身份信息和联系方式，包括但不限于身份证号码、手机号码和电子邮箱等。我们有权对管理平台账户进行审核，对于违反本条款约定的行为，我们有权视情况采取暂停使用、终止服务、冻结账号或注销等措施，您及客户应自行承担因此导致的后果。</p>
      <p>2.4 您了解并同意，本服务账号所有权及有关权益均归我们所有，完成首次登录后您将获得该账号的使用权。您的账号仅限本人使用，未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用。若因您主动泄露、遭受他人攻击、诈骗或管理不善造成账户（包括但不限于个人信息和密码等）被复制、盗用及其他行为而导致的损失及后果，均由您和客户自行承担。</p>
      <p>2.5 您充分了解并同意，您应为自己账号下的一切行为负责，您在账户项下的任何操作对您及客户均有法律约束力，并承担因使用我们的服务而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们无法且不会对您因前述风险而导致的任何损失或损害承担责任。</p>
      <p>2.6 您在本平台提供或填写的信息应是真实、准确、合法有效的，如有变化，您应及时修改并重新提交。若因您提交的信息不真实、不准确、不合法或失效，您应承担由此引起的不利后果。</p>
      <p>2.7 在您完成账号的注册、登录并进行合理和必要的身份验证后，如您是个人用户，您可随时浏览、修改自己提交的个人身份信息；如您是授权用户，您需要通过商户的管理员修改已经提交的身份信息。您理解并同意，出于安全性和身份识别（如账号或密码找回申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
      <p>2.8 您理解并同意，为了充分使用账号资源，如您在注册后未及时进行初次登录使用或连续超过12个月未登录账号并使用，我们有权收回您的账号或暂停服务。如您的账号被收回，您可能无法通过您此前持有的账号登录并使用本服务。</p>
      <p>2.9 您使用平台服务、参与平台活动等各个环节不得进行如下行为，否则我们有权冻结或限制全部或部分权限、功能（如账号被限制资金转出等功能）：</p>
      <p>（1）提交虚假信息，或盗用他人信息或资料，冒充、利用他人名义开展业务；</p>
      <p>（2）批量建立虚假账号；误导、欺骗他人；</p>
      <p>（3）未经允许，进入我们的计算机信息网络或者使用、删除、修改或者增加计算机信息网络资源；</p>
      <p>（4）使用未经平台授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响；</p>
      <p>（5）利用平台账号或本管理平台服务传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论，或者利用本平台服务从事窃取商业秘密、窃取个人信息等违法违规活动；从事违法犯罪活动；</p>
      <p>（6）我们根据合理分析判断您的账号操作、收益等存在异常的。</p>
      <p>（7）其他违反法律法规规定、侵犯其他用户合法权益、干扰我们正常运营或其他平台未明示授权的行为。</p>
      
      <h2 class="section-title">三、使用须知</h2>
      <p>3.1 您应自行诚信向我们提供您的个人资料，保证提供的资料真实、准确、完整、合法有效，您保证我们可以通过该等信息与您本人进行联系。您的个人资料如有变动，应及时自行或联系我们更新资料，避免因资料的无效性使您的合法权益受损。如果您提供的资料不合法、不真实、不准确、不详尽，您需承担因此引起的相应责任及后果，并且我们保留终止您使用本平台服务的权利。</p>
      <p>3.2 您在使用服务过程中，或将产生用户名和密码等账户等信息信息，您个人信息均由您保管，您可以根据平台规定变更您个人信息。通过您个人账号进行的一切操作视为您本人的操作行为。为保护您的权益，请您不要将账户转让或借给他人使用，否则由此产生的一切后果由您本人承担，与平台无关。</p>
      <p>3.3 在法律有明确规定要求我们作为平台服务提供者必须对部分用户（如平台商户等）的信息进行核实的情况下，管理平台将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。</p>
      <p>3.4 若您发现有人冒用、盗用、非法使用您的账号或您的账号存在安全漏洞的情况，请立即通知我们并向公安机关报案。</p>
      
      <h2 class="section-title">四、数据隐私与安全</h2>
      <p>4.1 我们非常重视您的个人信息保护，并会采取合理的措施保护您的个人信息。除法律法规规定的情形外，未经您的许可我们不会向第三方公开、透露您的个人信息。我们对相关信息采取专业加密存储与传输方式，保障您的个人信息安全。</p>
      <p>4.2 您在注册账号或使用本服务的过程中，可能需要提供一些必要的个人信息。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
      <p>4.3 您保证向管理平台提供的资料真实、合法、有效、完整，因您未提供真实、合法、有效、完整的资料或资料发生任何变更而没有及时通知管理平台导致本服务无法提供或提供时发生任何错误，由此产生的后果由您自行承担。若管理平台有合理理由怀疑您提供的资料不实、非法、无效或不完整，管理平台有权拒绝、暂停或终止向您提供本服务，管理平台对此不承担任何责任，您将承担因此产生的责任和损失。</p>
      <p>4.4 我们与您一同致力于您个人信息的保护，我们会在符合商业常理之范围内按照本协议及《隐私政策》的规定收集、使用、分享、存储和保护您的个人信息。《隐私政策》构成本协议的有效组成部分。尽管如此，我们无法保证您在网络上或通过网络进行信息传输的安全性或保密性。</p>
      
      <h2 class="section-title">五、知识产权</h2>
      <p>5.1 您了解并同意，除非我们另有说明或相关权利人依照法律规定享有权利，否则本服务包含的产品、技术、软件、程序、数据及其他所有信息内容，包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等（简称"平台内容"）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归我们或我们的关联公司所有。未经我们或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、转载、散布、传播、播放、展示、出售、许可、镜像、上载、下载本服务中的内容）。</p>
      <p>5.2 您应当和我们同样尊重知识产权。作为使用本服务的先决条件，您同意不会在使用本服务的过程中侵犯任何主体的知识产权（包括但不限于未经同意即擅自上传或分享他人受著作权法保护的材料）。</p>
      
      <h2 class="section-title">六、违约与赔偿</h2>
      <p>6.1 如果您违反本协议和/或其他您应遵守的服务条款与规则，我们有权根据独立判断，视情况在不经事先通知您的情况下采取合理的处置措施，包括但不限于预先警示、限制、暂停、终止您使用本服务的部分或全部功能，屏蔽或删除您上传、传播或提供的内容、限制账号部分或者全部功能、冻结或永久关闭账号等，您需自行承担由此导致的后果及损失。我们有权公告处理结果并有权根据实际情况决定是否恢复相关账号的使用，对已删除内容我们有权不予恢复或返还。对涉嫌违反法律法规、涉嫌违法犯罪的行为，我们将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。</p>
      <p>6.2 如果您违反本协议和/或其他您应遵守的服务条款与规则，引起第三方投诉、诉讼索赔等情况的，您应当自行处理并承担全部法律责任。若因您的违法或违约行为导致我们及我们的关联方、合作方等主体遭受任何损失（包括但不限于律师费用与支出）或行政处罚的，您应足额赔偿。</p>
      
      <h2 class="section-title">七、协议的生效、变更与转让</h2>
      <p>7.1 通过网络页面点击确认或同意接受本协议，或使用平台服务即视为您已阅读本协议并接受本协议的约束，本协议即刻生效。</p>
      <p>7.2 管理平台已提请您特别注意有关免除、限制银行责任，和管理平台单方面拥有某些权利以及增加您义务或免除、限制您权利的条款，并已应您的要求对上述条款予以充分解释说明，各方对本协议条款的理解完全一致，并自愿接受约束。</p>
      <p>7.3 鉴于互联网服务的特殊性，您授权并同意我们根据国家法律法规和政策的变化及时修订本协议。修订后的协议我们将通过原有展示方式向您公布，如您对本协议的修订有任何的疑问，可以拨打我们的服务专线进行咨询。</p>
      <p>7.4 本协议条款修改或变更后，如果您继续使用我们提供的系统或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用我们提供的服务。</p>
      <p>7.5 除非您与我们另有约定外，您同意本平台服务仅为您本人使用，您依本协议条款所取得的权利不可转让。</p>
      
      <h2 class="section-title">八、责任免除</h2>
      <p>8.1 您理解并同意，在使用本平台服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于硬件故障、信息网络维护与连接故障、通讯或其他系统故障，自然灾害（如火灾、洪水、风暴、地震等）以及社会事件（如战争、罢工、暴乱、爆炸、瘟疫流行、政府行为、司法行政机关命令等）等。出现上述情况时，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失我们在法律允许的范围内免责。</p>
      <p>8.2 您同意下列情形已超出我们的控制与合理预见，若因此给您造成了损失，我们可以免责：</p>
      <p>（1）您受到病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
      <p>（2）您的手机、电脑软件、系统、硬件和通信线路出现故障；</p>
      <p>（3）您操作不当或通过非平台授权的方式使用本服务；</p>
      <p>（4）平台系统不稳定或故障、通讯故障、银行原因、第三方服务瑕疵；</p>
      <p>（5）因您自身的原因导致的任何损失或责任，由您自行负责，本平台不承担责任。</p>
      <p>8.3 除上述免责情形外，其他非因平台故意或重大过失给您造成损失的，我们将不承担任何责任。</p>
      <p>8.4 我们仅限在"按现状"和"按现有"的基础上向您提供平台服务及活动，对于不可抗力或因第三方原因而造成的损害结果不承担责任。</p>
      <p>8.5 因不可抗力事件或风险事件导致您未能如期享有某项权益的，在不可抗力事件结束后或者在对风险事件评估后，我们将妥善为您解决。</p>
      
      <h2 class="section-title">九、服务的变更、中断、终止</h2>
      <p>9.1 我们可能会对平台服务内容进行变更，也可能会中断、中止或终止服务；</p>
      <p>9.2 您理解并同意，在我们发生合并、分立、收购、资产转让时，我们可向第三方转让本平台及相关服务。我们也可在单方通知您后，将本协议下部分或全部服务转交由符合条件的其他第三方运营或履行；</p>
      <p>9.3 如发生下列任何一种情形，我们有权不经通知而中断或终止向您提供的服务：</p>
      <p>（1）您提供的平台服务所需资料不真实、不准确、不合法或失效；</p>
      <p>（2）您违反相关法律法规或本协议的约定；</p>
      <p>（3）按照法律规定或主管部门的要求。</p>
      
      <h2 class="section-title">十、法律适用与管辖</h2>
      <p>10.1 本协议的订立、效力、解释、履行及争议的解决均适用中华人民共和国法律；法律无明文规定的，应适用平台制定的业务规则和通行的商业惯例。</p>
      <p>10.2 本协议的签订地为中华人民共和国安徽省合肥市，因本协议所引发的争议双方应尽量友好协商解决，协商不成的，您同意将争议提交至安徽省合肥市有管辖权的人民法院解决。</p>
      <p>10.3 本协议名称、条款的标题仅为查阅方便而设置，不应构成对本协议的任何解释，不对标题之下的内容及范围作任何限定。</p>
      
      <h2 class="section-title">十一、其他</h2>
      <p>11.1 协议内容与修订：本协议内容包括本协议正文及所有我们已经发布或将来可能发布的隐私政策、各项规则、通知。前述内容均为本协议不可分割的组成部分，与本协议具有同等法律效力。为给您提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，我们会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会以适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本，您也可以在网站首页或软件设置页面查阅最新版本的协议条款。如您对修订后的协议内容存有异议，您有权立即停止使用本服务。如您在修订协议生效日后继续使用本服务，即表示您已同意接受修订后的本协议内容。</p>
      <p>11.2 在本协议履行过程中，本平台向您发出的书面通知方式包括但不限于邮寄纸质通知、平台公告、电子邮件、站内通知、手机短信等方式。如以邮寄方式向您发出书面通知的，则在按照您在本平台留存的通讯地址交邮后的第三个自然日即视为送达，如以平台公告、电子邮件、站内通知、手机短信等电子方式发出书面通告的，则在通知发送成功即视为送达。</p>
      <p>11.3 如果您对本协议或平台的服务有任何的疑问、建议或投诉，可联系我们，我们会给予您必要的帮助。</p>
      <p>11.4 本协议中未尽事宜，按照法律法规和管理平台相关业务规则及国内通行的商业惯例办理。</p>
      <p>11.5 本协议中的标题仅为方便及阅读而设，并不影响本协议中任何规定的含义或解释。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServerAgreement',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.server-container {
  padding-bottom: 30px;
  background-color: #fff;
  min-height: 100vh;
}

.content {
  padding: 15px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #355DFF;
}

.intro {
  font-weight: bold;
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 10px;
  color: #355DFF;
}

p {
  margin-bottom: 10px;
  text-align: justify;
}

strong {
  font-weight: bold;
  color: #355DFF;
}
</style>
